import { render, staticRenderFns } from "./PrecificacaoClienteFinalTable.vue?vue&type=template&id=4f5c90ee"
import script from "./PrecificacaoClienteFinalTable.vue?vue&type=script&lang=js"
export * from "./PrecificacaoClienteFinalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports